import React, { ChangeEvent, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  FormControl,
  FormControlLabel,
  Checkbox,
  FormLabel,
  useTheme,
  FormGroup,
} from '@mui/material';
import SearchableDropdown from '../shared/components/SearchableDropdown';

interface AddSamplesModal {
  open: boolean;
  studyOptions: SearchableDropdownOption[];
  onClose: () => void;
  onApply: (studies: SearchableDropdownOption[], includeQCFail: boolean) => void;
}

const AddSamplesModal: React.FC<AddSamplesModal> = ({ open, onClose, onApply, studyOptions }) => {
    const [study, setStudy] = useState<SearchableDropdownOption[]>([]);
    const [qcPass, setQCPass] = useState<boolean>(true);


    return (
        <Dialog open={open} onClose={onClose} fullWidth>
        <DialogTitle>Add Samples</DialogTitle>
        <DialogContent>
        
        <div style={{'paddingTop': '10px'}}>
        <SearchableDropdown
            label="Study"
            value={study}
            setValue={setStudy}
            options={studyOptions}
            placeholder='Studies'
        />
        </div>
        <br/>
        <FormGroup>
          <FormControlLabel
            control={
              <Checkbox
                checked={qcPass}
                onChange={(event: ChangeEvent<HTMLInputElement>) =>
                  setQCPass(event.target.checked)
                }
              />
            }
            label="QC Pass Only"
          />
        </FormGroup>
        </DialogContent>
        <DialogActions>
            <Button onClick={onClose}>Cancel</Button>
            <Button variant="contained" color="primary" onClick={() => {onApply(study, !qcPass)}}>Apply</Button>
        </DialogActions>
        </Dialog>
    );
};

export default AddSamplesModal;
